import { FC } from "react";
import classNames from "classnames";
import { RowSeat } from "src/Modules/Flights/constants/JourneyDetails";
import RowItem from "../RowItem/RowItem";

export const MIN_SEAT_COLUMN_WIDTH = "clamp(3rem, 9vw, 4rem)";
export const SEAT_COLUMN_MIN_VAR = "var(--seat-col-min, 0px)";

const RowSeating: FC<{
  cols: [number, string][];
  row: RowSeat;
  onClick: any;
  reservedSeats: Set<string>;
  isMobile?: boolean;
}> = ({
  cols,
  row,
  onClick,
  reservedSeats,
  isMobile,
}) => {
  const minColWidth = isMobile === undefined ? SEAT_COLUMN_MIN_VAR : isMobile ? MIN_SEAT_COLUMN_WIDTH : "0";
  return (
    <div
      className={classNames("grid w-full items-center gap-2")}
      style={{
        gridTemplateColumns: `repeat(${cols.length}, minmax(${minColWidth},1fr))`,
      }}
    >
      {cols.map((col,index) => {
        return <RowItem row={row} col={col} onClick={onClick} reservedSeats={reservedSeats} key={`item-${index}`}/>;
      })}
    </div>
  );
};

export default RowSeating;
